import { render, staticRenderFns } from "./SetStatus.vue?vue&type=template&id=51adc081"
import script from "./SetStatus.vue?vue&type=script&lang=ts"
export * from "./SetStatus.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports